import { OUTPUT_MAPPINGS } from '@xmatters/common/constants/scriptSteps';

// Pulled into a util because this is used in a couple places.
// Dynamic output mappings are the value of an "I N P U T" that is named "Output Mappings".
// This function agregates and sorts all dynamic outputs on canvases per their flow block ID.
export const buildDynamicOutputsByBlockIdMap = (inputs = []) =>
  inputs.reduce((result, input) => {
    const isDynamicOutputsInput =
      input.scriptStepInput?.name === OUTPUT_MAPPINGS;
    if (isDynamicOutputsInput && input.value) {
      // eslint-disable-next-line no-param-reassign
      result[input.flowBlock.id] =
        JSON.parse(input.value).filter(
          dynO => dynO.name && dynO.dataOriginPointer,
        ) || [];
    }
    return result;
  }, {});
